<template>
  <div>
    <span :style="{ height, width: computedWidth }" :class="theme === 'light' ? 'SkeletonBox':'SkeletonBoxDark'" />
  </div>
</template>

<script>
export default {
  name: "SkeletonBox",
  props: {
    maxWidth: {
      // The default maxiumum width is 100%.
      default: 100,
      type: Number,
    },
    minWidth: {
      // Lines have a minimum width of 80%.
      default: 80,
      type: Number,
    },
    height: {
      // Make lines the same height as text.
      default: "1em",
      type: String,
    },
    width: {
      // Make it possible to define a fixed
      // width instead of using a random one.
      default: null,
      type: String,
    },
  },
  data() {
    return {
      xW: 1,
      cW: 1,
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    computedWidth() {
      // Either use the given fixed width or
      // a random width between the given min
      // and max values.

      return this.width || `${this.w}%`;
    },
    w() {
      return Math.floor(
        Math.random() * (this.maxWidth - this.minWidth) + this.minWidth
      );
    },
  },
  created() {
    // setInterval(() => {
    //   let n = Math.random();
    //   this.xW = Math.floor(
    //     n < 0.5 ? n * this.maxWidth * (1 + n) : 2 * n * this.maxWidth * 0.5
    //   );
    // }, 2000);
  },
};
</script>

<style lang="scss">
.SkeletonBox {
  display: inline-block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  background-color: #dddbdd;
  border-radius: 25px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.5) 60%,
      rgba(#fff, 0)
    );
    animation: shimmer 1s infinite;
    content: "";
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
.SkeletonBoxDark {
  display: inline-block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  background-color: #242b5083;
  border-radius: 25px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(#3f476f83, 0) 0,
      rgba(#3f476f83, 0.2) 20%,
      rgba(#3f476f83, 0.5) 60%,
      rgba(#3f476f83, 0)
    );
    animation: shimmer 1s infinite;
    content: "";
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>